<mits-header i18n-title title="Auftrag erstellen"></mits-header>
<ion-content>
  <form *ngIf="_FORM" [formGroup]="_FORM">
    <ion-list class="mits-form" inset lines="none">
      <mits-form-header
        i18n-title
        title="Kundendaten"
        i18n-description
        description="Kunden, Ansprechparter und Standort auswählen."
      >
      </mits-form-header>
      <mits-form-object-selection
        [dataFunction]="customersDataFunction"
        [loadingType]="'infinite-scroll'"
        [returnObjectsInsteadOfIds]="true"
        [titleFields]="['name1', 'name2']"
        [subtitleFields]="['snc_number']"
        (changedSelection)="customerSelectionChanged($event)"
        i18n-label
        label="Kunde"
        formControlName="customer"
      >
      </mits-form-object-selection>
      <mits-form-object-selection
        *ngIf="selectableCustomerContacts.length > 0"
        [data]="selectableCustomerContacts"
        [titleFields]="['firstname', 'lastname']"
        i18n-label
        label="Ansprechpartner"
        formControlName="customer_contact_id"
      >
      </mits-form-object-selection>
      <mits-form-object-selection
        *ngIf="selectableCustomerLocations.length > 0"
        [returnObjectsInsteadOfIds]="true"
        [data]="selectableCustomerLocations"
        [titleFields]="[
          'location_number',
          'name1',
          'name2',
          'floor',
          'floor_position'
        ]"
        [subtitleFields]="['typeDisplay']"
        (changedSelection)="resetOrderFormOnLocationChange()"
        label="Standort"
        i18n-label
        formControlName="location"
      >
      </mits-form-object-selection>
    </ion-list>
    <ion-list
      class="mits-form"
      *ngIf="_FORM.value.customer?.id"
      inset
      lines="none"
    >
      <mits-form-header
        i18n-title
        title="Auftragsdaten"
        i18n-description
        description="Details zum Auftrag auswählen."
      >
      </mits-form-header>
      <mits-form-object-selection
        *ngIf="_FS.checklistOnOrder"
        [multiple]="true"
        [disableSearch]="true"
        [returnObjectsInsteadOfIds]="true"
        [dataFunction]="checklistsDataFunction"
        [titleFields]="['name']"
        i18n-label
        label="Checklisten"
        formControlName="checklists"
      >
      </mits-form-object-selection>
      <mits-boilerplates
        class="mits-form-item"
        placeholder="Auftragsbeschreibung / Tätigkeit..."
        i18n-placeholder
        formControlName="description"
        useBoilerplates="ausstehende Arbeiten"
      >
      </mits-boilerplates>
    </ion-list>
    <ion-list
      class="mits-form"
      *ngIf="_FORM.value.customer?.id && _FORM.value.location?.id"
      inset
      lines="none"
      formControlStatus="assembly_reports"
    >
      <mits-form-header
        [showAdd]="
          !_FS.canOnlyAddSingleMachine || _FORM.value.machines?.length === 0
        "
        i18n-title
        title="Maschinen"
        addTriggerID="addMachineButton"
        i18n-description
        description="Maschinen für den Auftrag auswählen."
      >
      </mits-form-header>
      <mits-form-object-selection
        [dataFunction]="machinesDataFunction"
        [hideInputField]="true"
        [multiple]="!_FS.canOnlyAddSingleMachine"
        [enableScanner]="true"
        [returnObjectsInsteadOfIds]="true"
        [reinitOnNextModalOpen]="reinitMachineSelection"
        [titleFields]="machineSearchableTitleFields"
        [subtitleFields]="machineSearchableSubtitleFields"
        (changedSelection)="machineSelectionChanged($event)"
        i18n-label
        label="Maschine"
        externalTrigger="addMachineButton"
      >
      </mits-form-object-selection>
      <mits-data-grid
        *ngIf="_FORM.value.machines?.length > 0"
        [data]="_FORM.value.machines"
        [columnConfigs]="selectedMachinesColumnsConfig"
        [itemsClickable]="false"
        >,
      </mits-data-grid>
    </ion-list>
  </form>
</ion-content>

<mits-footer
  *ngIf="_FORM"
  [disabled]="_FORM?.invalid || isSaving"
  (buttonClicked)="save()"
  i18n-buttonText
  buttonText="Auftrag erstellen"
>
</mits-footer>
